import { MarketSpec } from '@/store/use-markets-store';
import { FilledOrder, PartiallyFilledOrder } from '@/store/use-orders-store';
import { OrderStatus, OrderType } from '@/types';
import { abbrFromSym } from '@/utils/token-symbol';
import { bigIntToDecimalStr, bigIntToNum } from '@/utils/value-format';
import { toast } from 'sonner';
import i18n from '@/lib/i18n';

export default function toastFilledOrder(
  order: FilledOrder | PartiallyFilledOrder,
  marketSpec: MarketSpec,
) {
  const { t } = i18n;
  const symAbbr = abbrFromSym(order.symbol);
  const lastFilledSizeStr = bigIntToDecimalStr(
    order.lastFilledSize,
    marketSpec.sizeDecimals,
  );
  const lastFilledSizePct =
    (bigIntToNum(order.lastFilledSize, marketSpec.sizeDecimals) /
      bigIntToNum(order.size, marketSpec.sizeDecimals)) *
    100;
  const lastFilledPriceStr = bigIntToDecimalStr(
    order.lastFilledPrice,
    marketSpec.priceDecimals,
  );

  // Display background notifications
  if (order.orderType === OrderType.LIQUIDATION) {
    toast.success(
      `${t('filledOrder.liquidated')} ${lastFilledSizeStr} ${symAbbr} at ${lastFilledPriceStr}.`,
    );
  } else if (order.orderType === OrderType.LIMIT) {
    toast.success(
      <span>
        {order.isBuy ? t('filledOrder.long') : t('filledOrder.short')}{' '}
        {lastFilledSizeStr} {symAbbr}
        {lastFilledSizePct < 100 ? ` (${lastFilledSizePct.toFixed(1)}%) ` : ' '}
        {order.status === OrderStatus.FILLED
          ? t('filledOrder.filledAt')
          : t('filledOrder.partiallyFilledAt')}{' '}
        {lastFilledPriceStr}.
        <br className="lg:hidden" />
        <span className="lg:hidden">
          {t('filledOrder.see')}{' '}
          <button
            className="font-medium underline"
            onClick={() => {
              const navigate = new CustomEvent('app:navigate', {
                detail: { pathname: '/portfolio' },
              });
              window.dispatchEvent(navigate);
            }}
          >
            {t('filledOrder.positions')}
          </button>
        </span>
      </span>,
    );
  } else if (order.orderType === OrderType.TAKE_PROFIT) {
    toast.success(
      `${t('filledOrder.takeProfit')} ${lastFilledSizeStr} ${symAbbr} ${t('filledOrder.filledAt')} ${lastFilledPriceStr}.`,
    );
  } else if (order.orderType === OrderType.STOP_LOSS) {
    toast.success(
      `${t('filledOrder.stopLoss')} ${lastFilledSizeStr} ${symAbbr} ${t('filledOrder.filledAt')} ${lastFilledPriceStr}.`,
    );
  }
}
